import React from 'react'
import { Box, Typography } from '@mui/material'
import { Modal, Button } from 'react-bootstrap'

export default function ActivityMapMobileModalShell({
  modern = false,
  show,
  onHide,
  onEntered,
  onExit,
  isMobileLayout,
  mobileDialogClassName,
  ariaLabelledBy,
  desktopDialogClassName,
  mobileEyebrow,
  mobileTitle,
  mobileBody,
  desktopChildren,
  mobileFooterClassName = 'activity-map-mobile-footer',
  closeButtonLabel = 'Cerrar'
}) {
  const dialogClassName = isMobileLayout
    ? `activity-map-modal-dialog${modern ? ' activity-report-modern' : ''}${mobileDialogClassName ? ` ${mobileDialogClassName}` : ''}`
    : [desktopDialogClassName, 'activity-map-modal-dialog-desktop'].filter(Boolean).join(' ')

  return (
    <Modal
      show={show}
      dialogClassName={dialogClassName}
      className="activity-map-modal"
      contentClassName={isMobileLayout ? 'activity-map-modal-content' : undefined}
      backdropClassName="activity-map-modal-backdrop"
      fullscreen={isMobileLayout}
      animation={!isMobileLayout}
      scrollable
      onHide={onHide}
      onEntered={onEntered}
      onExit={onExit}
      aria-labelledby={ariaLabelledBy}
    >
      {isMobileLayout ? (
        <>
          <Modal.Header
            closeButton={modern}
            closeLabel={closeButtonLabel}
            className="activity-map-mobile-header"
          >
            <Box className="activity-map-mobile-hero">
              {typeof mobileEyebrow === 'string' || typeof mobileEyebrow === 'number' ? (
                <Typography className="activity-map-mobile-eyebrow" component="div">
                  {mobileEyebrow}
                </Typography>
              ) : (
                mobileEyebrow
              )}
              <Modal.Title id={ariaLabelledBy} as="div">
                {mobileTitle}
              </Modal.Title>
            </Box>
          </Modal.Header>
          <Modal.Body className="activity-map-mobile-body">{mobileBody}</Modal.Body>
          {!modern && (
            <Modal.Footer className={mobileFooterClassName}>
              <Button
                variant="light"
                onClick={onHide}
                className="custom-close-button activity-map-mobile-close-button"
              >
                {closeButtonLabel}
              </Button>
            </Modal.Footer>
          )}
        </>
      ) : (
        desktopChildren
      )}
    </Modal>
  )
}
